import { createContext, useContext } from 'react';

import { Team, TeamMember, TeamRole } from '@this+that/models';

export interface InviteMemberFormType {
  inviteeRole: TeamRole;
  inviteeEmail: string;
}

export interface TeamInfo {
  name: string;
  userFeatures: string[];
  userRole: TeamRole;
}

export interface TeamMembersState {
  teamMembers: TeamMember[];
  userTeamIds: string[];
  isLoading: boolean;
  teamInfo: TeamInfo;
}

export interface TeamMembersContextProps {
  state: TeamMembersState;
  isLoading: boolean;
  isInviteLoading: boolean;
  handleRemoveMember: (teamId: string, id?: string) => Promise<void>;
  handleDeleteInvite: (teamId: string, email?: string) => Promise<void>;
  removeLoading: boolean;
  handleAddMember: (data: InviteMemberFormType) => Promise<any | null>;
  handleUpdateTeamMember: (teamInstance: Team) => Promise<any | null>;
}

export const TeamMembersContext = createContext<
  TeamMembersContextProps | undefined
>(undefined);

export const useTeamMembers = (): TeamMembersContextProps => {
  const context = useContext(TeamMembersContext);
  if (!context) {
    throw new Error('useTeamMembers must be used within a TeamMemberProvider');
  }
  return context;
};
